import { ContractorScopesDto } from '@artemis-software/wr-api';
import { Permission } from '@services/current-user.service';
import ScopesEnum = ContractorScopesDto.ScopesEnum;

export enum BuildingTab {
  BuildingData = 'baseData',
  Entrances = 'entrances',
  Units = 'units',
  SubTenant = 'Untermieter',
  Responsibilities = 'responsibilities',
  Contacts = 'contacts',
  EmergencyContacts = 'emergencyContacts',
  HouseCareContacts = 'houseCareContacts',
  Inspections = 'inspections',
  Protocols = 'protocols',
  RepairTasks = 'repairTasks',
  BuildingEquipments = 'buildingEquipments',
  Scans = 'scans',
  Sensors = 'sensors',
  EnergyCertificate = 'energieausweis',
  Documents = 'documents',
  HoraPass = 'horaPass',
  Notes = 'notes',
  BillingAddresses = 'billingAddresses',
  ProfiNeo = 'profiNeo',
  ProfiNeoSanierung = 'profiNeoSanierung',
  Settings = 'settings',
}

export const buildingTabTranslations: Record<BuildingTab, string> = {
  [BuildingTab.BuildingData]: 'Grunddaten',
  [BuildingTab.Entrances]: 'Eingänge',
  [BuildingTab.Units]: 'Einheiten',
  [BuildingTab.SubTenant]: 'Untermieter',
  [BuildingTab.Responsibilities]: 'Zuständigkeiten',
  [BuildingTab.Contacts]: 'Kontakte',
  [BuildingTab.EmergencyContacts]: 'Notfallkontakte',
  [BuildingTab.HouseCareContacts]: 'Hausbetreuung',
  [BuildingTab.Inspections]: 'Rundgänge',
  [BuildingTab.Protocols]: 'Protokolle',
  [BuildingTab.RepairTasks]: 'Reparaturaufträge',
  [BuildingTab.BuildingEquipments]: 'TGAs',
  [BuildingTab.Scans]: 'Scans',
  [BuildingTab.Sensors]: 'Sensoren',
  [BuildingTab.EnergyCertificate]: 'Energieausweis',
  [BuildingTab.Documents]: 'Dokumente',
  [BuildingTab.HoraPass]: 'HORA-Pass',
  [BuildingTab.Notes]: 'Notizen',
  [BuildingTab.BillingAddresses]: 'Rechnungsadressen',
  [BuildingTab.ProfiNeo]: 'Profi.neo',
  [BuildingTab.ProfiNeoSanierung]: 'Profi.neo Sanierung',
  [BuildingTab.Settings]: 'Einstellungen',
};

export interface BuildingTabConfig {
  visibleWhenNew: boolean,
  showControls: boolean,
  // TODO: maybe refactor so scope is resolved via permission and client does not need to check
  visibilityScope?: { scope?: ScopesEnum, permission?: Permission };
}

export const buildingTabConfig: Record<BuildingTab, BuildingTabConfig> = {
  [BuildingTab.BuildingData]: {
    visibleWhenNew: true,
    showControls: true,
    visibilityScope: { scope: ScopesEnum.BuildingBaseData }
  },
  [BuildingTab.Entrances]: {
    visibleWhenNew: true,
    showControls: true,
    visibilityScope: { scope: ScopesEnum.BuildingBaseData }
  },
  [BuildingTab.Units]: { visibleWhenNew: false, showControls: true, visibilityScope: { permission: 'viewUnits' } },
  [BuildingTab.SubTenant]: { visibleWhenNew: false, showControls: false },
  [BuildingTab.Responsibilities]: { visibleWhenNew: false, showControls: true, },
  [BuildingTab.Contacts]: { visibleWhenNew: false, showControls: true },
  [BuildingTab.EmergencyContacts]: { visibleWhenNew: false, showControls: true },
  [BuildingTab.HouseCareContacts]: { visibleWhenNew: false, showControls: true },
  [BuildingTab.Inspections]: {
    visibleWhenNew: false,
    showControls: false,
    visibilityScope: { scope: ScopesEnum.BuildingInspections }
  },
  [BuildingTab.Protocols]: { visibleWhenNew: false, showControls: true },
  [BuildingTab.RepairTasks]: { visibleWhenNew: false, showControls: false },
  [BuildingTab.BuildingEquipments]: {
    visibleWhenNew: false,
    showControls: false,
    visibilityScope: { scope: ScopesEnum.BuildingTgas }
  },
  [BuildingTab.Scans]: {
    visibleWhenNew: false,
    showControls: true,
    visibilityScope: { scope: ScopesEnum.BuildingScans }
  },
  [BuildingTab.Sensors]: {
    visibleWhenNew: false,
    showControls: false,
    visibilityScope: { scope: ScopesEnum.BuildingSensors }
  },
  [BuildingTab.EnergyCertificate]: {
    visibleWhenNew: false,
    showControls: false,
    visibilityScope: { scope: ScopesEnum.BuildingSensors }
  },
  [BuildingTab.Documents]: {
    visibleWhenNew: false,
    showControls: false,
    visibilityScope: { scope: ScopesEnum.BuildingDocuments, permission: 'viewAttachmentFolderContents' }
  },
  [BuildingTab.HoraPass]: { visibleWhenNew: false, showControls: false },
  [BuildingTab.Notes]: { visibleWhenNew: false, showControls: true },
  [BuildingTab.BillingAddresses]: {
    visibleWhenNew: false,
    showControls: true,
    visibilityScope: { scope: ScopesEnum.BuildingBaseData }
  },
  [BuildingTab.ProfiNeo]: { visibleWhenNew: false, showControls: true },
  [BuildingTab.ProfiNeoSanierung]: { visibleWhenNew: false, showControls: true },
  [BuildingTab.Settings]: { visibleWhenNew: false, showControls: true },
};

export const buildingTabs = Object.values(BuildingTab) as BuildingTab[];
